import { render, staticRenderFns } from "./ProductEditAccounting.vue?vue&type=template&id=2a45a238"
import script from "./ProductEditAccounting.vue?vue&type=script&lang=ts"
export * from "./ProductEditAccounting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports